module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAARCAYAAADQWvz5AAAABHNCSVQICAgIfAhkiAAAARJJREFUOE+llIFRAjEQRd+vQDtQKkArACvQDsQOpAKhAzoQOrADLYEOpASoYJ3PJMxdzHGc7szNXTa7Lz972YgzFhFPwDuwljQ/F6se0A64STEjSR5XrRMUEbOkJiduJNk3GNRUk5M7VVUVRcQCeKss/QG8SNqXc4qIW+AZuAP87XefGbTNj6SNQXZe9WX2zN8b9AVM/gE6eBcGXQOGjf8AM2QqaXssdoK5kEOUnSBmtP5aRBj2eIGyFqQG6vrtJXsnadR0loouLrykVm4JGnIUHiR54aOdQOlgfhd7cC3WgG+B3Lw5ZC5pVQNNgc80YYCDVrkdUhO7hhm4lORxW1E6Bq/J7/vnVz+lGN8AbqNFM+YHMqhoXHZJdU0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/examinatSystem/setCollectIcon.png
// module id = YR1J
// module chunks = 3